export default {
    common: {
        ok: 'OK',
        cancel: 'Cancel',

        tab_bookcase: 'Library',
        tab_library: 'Discover',
        tab_welfare: 'Benefits',
        tab_my: 'Me',

        library_refresh_success: 'Refreshed',
        library_loading: 'Loading...',
        pull_refresh_pulling: 'Pull down to refresh...',
        pull_refresh_loosing: 'Release to refresh...',
        library_no_books: 'No books',
        library_list_end: 'No more',

        library_more: 'More',
        library_score_suffix: ' pts',
        library_hot: ' hot',
        library_serializing: 'Ongoing',
        library_finished: 'Complete',
        library_no_image: 'No image',
        library_no_more: 'No more',

        more_title: "Today's Picks",
        more_tab_new: 'New',
        more_tab_finish: 'Complete',

        directory_title: 'Catalog',
        directory_chapters: '{0} chapters',
        free: 'Free',
        no_chapters: 'No chapters',

        details_title: 'Book Details',
        details_reading: 'Reading',
        details_popularity: 'Popularity',
        details_catalog: 'Catalog',
        details_updated_at: 'Updated',
        details_chapters_suffix: ' ch',
        details_comments_section: 'Comments',
        details_comments_suffix: ' comments',
        details_write_review: 'Write review',
        details_no_comments: 'No comments',
        details_view_all: 'View all',
        details_guess_like: 'You may like',
        details_refresh: 'Refresh',
        details_in_shelf: 'In shelf',
        details_add_shelf: 'Add to shelf',
        details_read_now: 'Read now',

        book_review_title: 'Reviews',
        free_read: 'Free read',
        rating_bad: 'Poor',
        rating_fair: 'Fair',
        rating_ok: 'OK',
        rating_good: 'Good',
        rating_best: 'Best',
        people_rated_suffix: ' rated',
        review_write: 'Write review',
        tab_review_new: 'Latest',
        tab_review_recommend: 'Featured',
        no_reviews: 'No reviews',

        bookdetails_title: 'Review Details',
        eval_title: 'Rate this book',
        eval_publish: 'Publish',
        eval_placeholder: 'Share your thoughts on plot, characters, etc.',
        eval_success: 'Comment published',

        reading_need_beans: 'This chapter requires',
        reading_beans: ' coins',
        reading_need_beans_suffix: ' to read',
        reading_read_minutes: 'Read',
        reading_minutes_suffix: ' min',
        login_btn: 'Log in',
        follow_qr_tip: 'Scan QR code to follow',
        unlock_more: 'Unlock more chapters',
        follow_refresh_tip: 'Followed. Refresh from the top-right menu.',
        auth_login_toast: 'Authorizing',
        login_success_toast: 'Logged in',
        add_shelf_confirm_title: 'Add to shelf',
        add_shelf_confirm_msg: 'Add this book to your shelf?',
        add_shelf_confirm_btn: 'Add',
        add_shelf_cancel_btn: 'Not now',
        please_login_toast: 'Please log in',
        vip_activated_toast: 'VIP unlimited reading enabled',
        auto_buy_on_toast: 'Auto-purchase chapters on',
        auto_buy_off_toast: 'Auto-purchase chapters off',
        pay_price_label: 'Price',
        pay_balance_label: 'Balance',
        purchase_success_toast: 'Chapter purchased',
        last_page_toast: 'Last page',
        first_page_toast: 'First page',

        login_account: 'Account login',
        login_code: 'Code login',
        login_phone_placeholder: 'Enter phone number',
        login_password_placeholder: 'Enter password',
        login_btn_text: 'Log in',
        login_forget: 'Forgot password',
        login_register: 'Register',
        login_wx: 'WeChat login',
        login_qq: 'QQ login',
        login_facebook: 'Sign in with Facebook',
        login_google: 'Sign in with Google',
        login_continue_email: 'Continue with Email',
        login_or: 'or',
        login_agreement_prefix: 'By logging in you agree to the ',
        login_user_agreement: 'User Agreement',
        login_and: ' and ',
        login_privacy: 'Privacy Policy',
        login_success: 'Logged in',
        login_code_placeholder: 'Enter verification code',
        login_get_code: 'Get code',
        login_resend_after: 's resend',
        login_send_fail: 'Send failed',

        settings_title: 'Settings',
        settings_avatar: 'Avatar',
        settings_nickname: 'Nickname',
        settings_gender: 'Gender',
        settings_gender_placeholder: 'Select gender',
        settings_male: 'Male',
        settings_female: 'Female',
        settings_secret: 'Prefer not to say',
        settings_signature: 'Signature',
        settings_account_binding: 'Account & Binding',
        settings_logout: 'Log out',
        settings_edit_nickname: 'Edit nickname',
        settings_nickname_placeholder: 'Enter nickname...',
        settings_nickname_rule: '2-10 chars; Chinese/English/numbers',
        settings_updating: 'Updating...',
        settings_avatar_success: 'Avatar updated',
        settings_success: 'Updated',
        settings_nickname_short: 'Nickname must be at least 2 characters',
        settings_logout_title: 'Log out',
        settings_logout_msg: 'Are you sure?',
        settings_logout_confirm: 'Log out',
        settings_logout_cancel: 'Stay',
        settings_logout_success: 'Logged out',
        settings_take_photo: 'Take photo',
        settings_choose_album: 'Choose from album',

        my_not_logged_in: 'Not logged in',
        my_sign_placeholder: 'Set your signature',
        my_minutes: ' min',
        my_read_today: 'Reading today',
        my_wallet: 'My Wallet',
        my_bean_balance: 'Coins',
        my_today_bean: 'Today\'s coins',
        my_topup_now: 'Top up',
        my_vip_until: 'VIP until {0}',
        my_vip_lifetime: 'Lifetime VIP Member',
        my_vip_open: 'Get more with membership',
        my_vip_center: 'Membership',
        my_vip_open_btn: 'Get membership',
        my_messages: 'Messages',
        my_settings: 'Settings',
        my_menu_1: 'Invite Friends',
        my_menu_2: 'Reading Preferences',
        my_menu_3: 'Reading History',
        my_menu_4: 'My Reviews',
        my_menu_5: 'Customer Service',
        my_menu_6: 'My Membership',
        my_menu_7: 'Creator Center',

        welfare_title: 'Benefits',
        welfare_beans: ' coins',
        welfare_sign_today: 'Sign today to get',
        welfare_sign_now: 'Sign now',
        welfare_sign_week: 'Sign 7 days this week, get up to',
        welfare_daily: 'Daily',
        welfare_invite_reward: 'Invite friends to earn coins',
        welfare_go_invite: 'Invite',
        welfare_read_daily: 'Daily reading',
        welfare_today_read: 'Today: ',
        welfare_read_total: 'Read {0} min',
        welfare_read_reach: 'Read {0} min to get {1} coins',
        welfare_claimed: 'Claimed',
        welfare_go_read: 'Read',
        welfare_sign_success: 'Signed in!',
        welfare_get: 'Got',
        welfare_ok: 'OK',

        login_forget_pwd: 'Reset password',
        login_set_password: 'Set password',
        login_confirm_password: 'Confirm password',
        login_have_account: 'Already have an account? ',
        login_confirm: 'Confirm',
        login_forget_success: 'Password reset',
        login_invite_code_placeholder: 'Enter invite code',
        login_register_success: 'Registered',
        agreement_title: 'User Agreement',
        privacy_title: 'Privacy Policy',

        bookcase_title: 'Bookshelf',
        bookcase_selected_count: '{0} selected',
        bookcase_search: 'Search shelf',
        bookcase_today_read: 'Read today',
        bookcase_sign_beans: 'Sign in for coins',
        bookcase_empty: 'Shelf is empty',
        bookcase_remove: 'Remove from shelf',
        bookcase_record: 'Reading history',
        bookcase_organize: 'Organize shelf',
        bookcase_sort: 'Sort books',
        bookcase_sort_update: 'By update time',
        bookcase_sort_read: 'By read time',
        bookcase_select_all: 'Select all',
        bookcase_unselect_all: 'Deselect all',
        bookcase_select_remove: 'Please select books to remove',
        bookcase_remove_title: 'Remove',
        bookcase_remove_msg: 'Remove these books from shelf?',
        bookcase_no_organize: 'No books to organize',

        search_placeholder: 'Book title or author',
        search_history: 'Search history',
        search_clear: 'Clear',
        search_hot: 'Hot search',
        search_recommend: 'Recommended',
        search_all_results: 'All results',
        search_no_books: 'No such books',
        search_no_clear: 'Nothing to clear',
        search_clear_title: 'Clear',
        search_clear_msg: 'Clear all?',
        search_score: 'Score',

        reading_prev_chapter: 'Previous',
        reading_next_chapter: 'Next',
        reading_bg: 'Background',
        reading_font: 'Font',
        reading_font_size_toast: 'Font size: {0}',
        reading_auto_buy: 'Auto-purchase chapters',
        reading_order_normal: 'Normal',
        reading_order_reverse: 'Reverse',
        reading_pay_order: 'Order',
        reading_per_chapter: '/chapter',
        reading_buy_chapter: 'Buy chapter',
        reading_vip_free_all: 'VIP reads all free',
        reading_vip_free_before: 'VIP ',
        reading_vip_free_after: ' for all books',
        reading_open_vip: 'Get VIP',
        reading_topup_beans: 'Top up coins',

        vip_open: 'Get VIP',
        vip_until_at: 'VIP until {0}',
        vip_privilege_tip: 'Unlock all VIP benefits',
        vip_renew: 'Renew',
        vip_open_now: 'Get VIP',
        vip_benefits: 'VIP benefits',
        vip_choose_package: 'Choose plan',
        vip_gift_days: '+{0} days',
        vip_honor: 'Premium',
        vip_pay_weixin: 'WeChat Pay',
        vip_pay_alipay: 'Alipay',

        wallet_title: 'My Wallet',
        wallet_bean_balance: 'Coins',
        wallet_withdraw: 'Withdraw',
        wallet_about_rmb: '≈ {0}',
        wallet_topup: 'Top up',
        wallet_today_bean: 'Today\'s coins',
        wallet_total_bean: 'Total coins',
        wallet_bean_intro: 'About coins',
        wallet_what_bean: 'What are coins?',
        wallet_detail: 'Coin history',

        record_title: 'Reading history',
        record_shelf: 'Shelf',
        record_delete: 'Delete',
        record_empty: 'No reading history yet',

        binding_title: 'Account & Binding',
        binding_phone: 'Phone',
        binding_bound: 'Bound',
        binding_go_bind: 'Bind',

        topup_title: 'Top up',
        topup_gift: '+{0} coins',
        topup_tip_title: 'Notice',
        topup_tip_msg: 'If top-up fails, contact support from Me > Customer.',
        topup_success: 'Topped up',
        topup_weixin_toast: 'WeChat Pay',
        topup_alipay_toast: 'Alipay',

        invite_title: 'Invite friends, earn coins',
        invite_rules: 'Rules',
        invite_slogan: 'Invite friends for coins',
        invite_sub: 'Earn more',
        invite_cash: 'Redeemable',
        invite_tip: 'Invitees get reward after registration.',
        invite_btn: 'Invite now',
        invite_reward: 'Invite rewards',
        invite_day: 'Day {0}',
        invite_read_min: 'Friend reads {0} min',
        invite_flow: 'How it works',
        invite_flow1: 'Share link or QR code',
        invite_flow2: 'Friend downloads and registers',
        invite_flow3: 'You earn coins when they register',
        invite_tips: 'Tips',
        invite_get_fail: 'Failed to load',

        system_title: 'Messages',
        system_tab_sys: 'System',
        system_tab_praise: 'Likes',
        system_tab_review: 'My reviews',
        system_view_detail: 'View',
        system_no_msg: 'No messages',
        system_delete_confirm_title: 'Delete',
        system_delete_confirm_msg: 'Delete this comment?',

        customer_title: 'Support',
        customer_contact: 'Contact',
        customer_contact_tip: 'Call, WeChat or QQ for support.',
        customer_copy: 'Copy',
        customer_copied: 'Copied',
        customer_faq: 'FAQ',
        customer_copy_ok: 'Copied',
        customer_copy_fail: 'Copy not supported',

        replace_binding_title: 'Change binding',
        replace_phone_title: 'Bind phone',
        replace_phone_placeholder: 'Enter your phone number',
        replace_change_phone_title: 'Change phone',
        replace_change_phone_msg: 'Change phone number?',
        replace_confirm_change: 'Change',
        replace_success: 'Changed',
        replace_bind_success: 'Bound',
        login_set_password_8: 'Set password (min 8 digits)',

        fond_choose_type: 'Choose your favorites',
        fond_recommend: 'Recommended for you',
        fond_sheet_title: 'Choose reading preferences',
        fond_set_success: 'Saved',

        subsidiary_detail_title: 'Withdrawal details',
        subsidiary_success: 'Withdrawn',
        subsidiary_arrive_time: 'Arrival time',
        subsidiary_arrive_way: 'Method',
        subsidiary_arrive_amount: 'Amount',
        subsidiary_weixin: 'WeChat',
        subsidiary_alipay: 'Alipay',
        subsidiary_got_it: 'OK',
        subsidiary_list_title: 'Withdrawal history',
        subsidiary_withdraw_bean: 'Withdraw {0} coins',
        subsidiary_audit: 'Pending',
        subsidiary_fail: 'Failed',
        subsidiary_empty: 'No withdrawal history',

        personality_title: 'Signature',
        personality_save: 'Save',

        progress_title: 'Withdrawal progress',
        progress_submit: '{0} withdrawal submitted',
        progress_got_it: 'OK',
        progress_tip: 'View details in withdrawal history',

        rules_title: 'Rules',

        withdrawal_title: 'Withdraw',
        withdrawal_detail: 'History',
        withdrawal_bean_withdraw: 'Coin withdrawal',
        withdrawal_rmb: 'Withdraw {0}',
        withdrawal_way: 'Withdrawal method',
        withdrawal_weixin_account: 'WeChat',
        withdrawal_alipay_account: 'Alipay',
        withdrawal_add_account: 'Add account',
        withdrawal_select_amount: 'Select amount',
        withdrawal_select_account: 'Select account',
        withdrawal_confirm_title: 'Withdraw',
        withdrawal_confirm_msg: 'Confirm withdrawal?',
        withdrawal_think_again: 'Cancel',
        withdrawal_success: 'Withdrawn',

        system_detail_title: 'System message',

        account_title: 'Add account',
        account_type_placeholder: 'Select account type',
        account_placeholder: 'Enter account',
        account_name_placeholder: 'Enter name',
        account_weixin: 'WeChat',
        account_alipay: 'Alipay',

        binding_toast_weixin: 'WeChat login',
        binding_toast_qq: 'QQ login',
        binding_unbind_weixin_title: 'Unbind WeChat',
        binding_unbind_weixin_msg: 'Unbind WeChat? You won\'t be able to login with WeChat.',
        binding_unbind_qq_title: 'Unbind QQ',
        binding_unbind_qq_msg: 'Unbind QQ? You won\'t be able to login with QQ.',
        binding_unbind_btn: 'Unbind',

        record_clear_title: 'Clear',
        record_clear_msg: 'Clear all reading history?',
        record_delete_msg: 'Delete?',

        vip_choose_package_toast: 'Please select a package',

        welfare_free_unlock: 'Go',
        welfare_watch_video: 'Watch ad',
        welfare_watch_video_desc: 'Watch an ad to earn a reward',
        welfare_watch_video_remain: '{0} left',
        welfare_watch_video_full: 'No more ad views today',
        welfare_visit_site: 'Visit site',
        welfare_visit_site_desc: 'Read an article and stay 20 seconds to earn a reward',
        welfare_visit_site_remain: '{0} left',
        welfare_visit_site_full: 'No more visits today',
        welfare_visit_site_timer: 'Claim in {0}s',
        welfare_visit_site_claim: 'Claim coins',
        welfare_visit_site_too_short: 'Not enough reading time, please try again',
        open_browser_tip: 'Better experience in external browser',
        welfare_popup_title: 'Not enough coins — earn some free!',
        welfare_popup_go: 'Go to Benefits Center',
        guest_topup_success_title: 'Top-up successful!',
        guest_topup_success_msg: 'Coins saved to your guest account. Log in to keep them forever across all devices.',
        guest_login_now: 'Log in / Register',
        guest_later: 'Not now',

        book_read_progress: 'Ch. {0}/{1} read',
        book_unread: 'Unread',
        review_from_book: 'From: "{0}"',
        currency_cny_suffix: ' CNY',

        share_arrow_tip: 'Tap ··· in the top right',
        share_earn_coins: 'Share & earn coins',
        share_subtitle: 'Millions of popular titles',
        share_recommend: 'Reader picks',
        share_slogan: 'Read anytime, anywhere',
        share_more: 'More content to explore',
    },
    api: {
        // 成功类
        add_success: 'Added successfully',
        update_success: 'Updated successfully',
        delete_success: 'Deleted successfully',
        restore_success: 'Restored successfully',
        operation_success: 'Operation successful',
        review_success: 'Reviewed successfully',
        topup_success: 'Topped up successfully',
        publish_success: 'Published successfully',
        reply_success: 'Replied successfully',
        purchase_success: 'Purchased successfully',
        remove_success: 'Removed successfully',
        clear_success: 'Cleared successfully',
        join_success: 'Joined successfully',
        reward_success: 'Tipped successfully',
        apply_success: 'Applied successfully',
        apply_success_pending: 'Applied, pending review',
        like_success: 'Liked',
        cancel_success: 'Cancelled',
        send_success: 'Sent successfully',
        claim_success: 'Claimed successfully',
        logout_success: 'Logged out',
        unbind_success: 'Unbound successfully',
        // 失败/错误类
        publish_failed: 'Publish failed',
        verify_failed: 'Verification failed',
        operation_failed: 'Operation failed',
        update_failed: 'Update failed',
        fetch_failed: 'Failed to load',
        book_create_failed: 'Failed to create book',
        chapter_exists: 'Chapter already exists',
        param_error: 'Invalid parameters',
        account_error: 'Account error',
        account_password_error: 'Incorrect account or password',
        captcha_error: 'Invalid verification code',
        content_required: 'Content cannot be empty',
        phone_required: 'Please enter your phone number',
        identifier_required: 'Please enter an identifier',
        user_wechat_not_bound: 'WeChat not bound to this account',
        writer_not_verified: 'Writer not verified',
        writer_reviewing: 'Writer verification in review',
        writer_review_failed: 'Writer verification failed',
        api_key_error: 'Invalid API key',
        // --- Service layer errors ---
        add_failed: 'Failed to add',
        delete_failed: 'Failed to delete',
        restore_failed: 'Failed to restore',
        review_failed: 'Review failed',
        upload_failed: 'Upload failed',
        topup_failed: 'Top-up failed',
        topup_payment_failed: 'Top-up payment failed',
        topup_info_not_found: 'Top-up information not found',
        topup_once_limit: 'This top-up option can only be used once, please choose another',
        bind_failed: 'Binding failed',
        already_bound_other_account: 'This account is already bound to another user',
        already_bound: 'Already bound, please do not bind again',
        bind_same_phone: 'Please do not rebind the same phone number',
        register_failed: 'Registration failed',
        order_not_found: 'Order not found',
        order_create_failed: 'Failed to create order',
        user_not_found: 'User not found',
        phone_invalid: 'Invalid phone number',
        phone_registered: 'Phone number already registered',
        account_name_required: 'Please enter your account name',
        password_required: 'Please enter your password',
        password_mismatch: 'Passwords do not match',
        original_password_error: 'Incorrect original password',
        password_change_failed: 'Failed to change password',
        password_already_set: 'Password already set',
        account_disabled: 'Account has been disabled, please contact support',
        insufficient_coins: 'Not enough coins, please top up',
        commission_ratio_exceeded: 'Commission ratio cannot exceed your own ratio',
        daily_visits_exceeded: 'Daily visit limit reached',
        daily_watch_exceeded: 'Daily watch limit reached',
        already_liked: 'You have already liked this',
        already_collected: 'Already in your collection',
        already_applied: 'Application already submitted, please do not apply again',
        already_added: 'Already added, please do not add again',
        please_login: 'Please log in first',
        paid_chapter_login_required: 'This is a paid chapter, please log in to read',
        read_preference_required: 'Please select your reading preferences',
        book_type_required: 'Please select a genre you enjoy',
        nickname_required: 'Please enter a nickname to change to',
        keyword_required: 'Please enter a keyword',
        comment_required: 'Comment cannot be empty',
        nickname_in_use: 'This pen name is already taken',
        unsupported_platform: 'Unsupported third-party platform',
        re_login_third_party: 'Please log in again through the third-party platform',
        param_required: 'Parameters cannot be empty',
        product_type_not_found: 'Product type not found',
        payment_type_invalid: 'Invalid payment type parameter',
        receipt_required: 'Payment receipt cannot be empty',
        payment_verify_failed: 'Payment verification failed',
        unified_order_failed: 'Failed to create unified order',
        withdraw_amount_zero: 'Withdrawal amount cannot be 0',
        withdraw_amount_min: 'Minimum withdrawal amount is 1 yuan',
        withdraw_failed: 'Withdrawal failed',
        withdraw_info_not_found: 'Withdrawal information not found',
        withdraw_apply_success: 'Withdrawal applied, pending platform review',
        apply_failed: 'Application failed, please try again',
        publish_failed_retry: 'Publish failed, please try again',
        operation_failed_retry: 'Operation failed, please try again',
        request_failed: 'Request failed, please try again later',
        h5_domain_required: 'Please configure the H5 site domain',
        missing_upload_image: 'Missing uploaded image file',
        missing_upload_file: 'Missing uploaded file',
        missing_user_profile: 'Missing user profile data',
        missing_code_param: 'Missing parameter CODE, please check',
        chapter_not_found: 'Chapter catalog not found',
        message_type_invalid: 'Invalid message type',
        agent_account_exists: 'Agent account already exists',
        account_type_required: 'Please select an account type',
        message_id_required: 'Please select a message ID',
        message_type_required: 'Please select a message type',
        openid_required: 'OPENID is required',
        waiting_scan: 'Waiting for QR code scan...',
    },
}
